import { AbstractControl, ValidatorFn } from '@angular/forms';

export function fileTypeValidator(file): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (file) {
      
        // If the file size exceeds the maximum size, return an error object
        return { 'fileTypeWrong': true };
      
    }
    // If no file or file size is within limits, return null (no error)
    return null;
  };
}

